import httpClient from "./httpClient";

export async function submitContactMessage(body) {
  const { data } = await httpClient.post("/contact", body);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await httpClient.post("/newsletter/subscribe", { email });
  return data;
}
